/**
 * Métricas públicas del marketplace Coolliving.
 * Centralizadas para mantener coherencia entre landing, SEO y fallbacks estáticos.
 *
 * Última actualización: 2026-11-04 (API live: hub total 6.912 resultados).
 * Revisar y actualizar tras cada scrape o sync importante del catálogo.
 */
export const SITE_METRICS = {
  roomCountLabel: '6.900+',
  roomCountLabelEn: '6,900+',
  roomCountNum: 6900,
  cityCount: 15,
  minPrice: '350€',
  minPriceMarketing: '350€',
  minPriceEn: '€350',
}
